/**
 * Aviso en la PESTAÑA del navegador cuando un cliente escribe en la conversación
 * que ESTA pestaña tiene abierta, estando la pestaña en segundo plano
 * (Victor 2026-06-03 · Propuesta 5 aprobada).
 *
 * Hace dos cosas mientras la pestaña no esté al frente:
 *   1. Parpadea el título entre "(N) Chatwoot" y "💬 {Cliente} escribió".
 *   2. Dibuja un contador rojo sobre el favicon (canvas, mismo origen).
 *
 * Se resetea solo al volver a enfocar/ver la pestaña.
 */
const BASE_NAME = 'Chatwoot';
const BLINK_MS = 1500;

let count = 0;
let lastName = '';
let blinkTimer = null;
let showAlt = false;
let originalTitle = null;
let listenerBound = false;
// Título base de ESTA pestaña = "{Cliente} · CRM" del chat abierto (Victor
// 2026-06-04 · Propuesta 3). Lo fija ConversationBox al abrir/cambiar de chat.
// El aviso alterna entre "💬 {Cliente} escribió" y este título base.
let baseTitle = null;

const sizeOf = link => (link.sizes && link.sizes[0]) || '32x32';
// Ruta del favicon LIMPIO (sin badge), igual que initFaviconSwitcher.
const cleanFaviconHref = link => `/favicon-${sizeOf(link)}.png`;

const captureOriginals = () => {
  if (originalTitle === null) originalTitle = document.title || BASE_NAME;
};

// Dibuja el favicon limpio + un círculo rojo con el contador arriba a la derecha.
const paintFavicon = () => {
  document.querySelectorAll('link.favicon').forEach(link => {
    const px = parseInt(sizeOf(link), 10) || 32;
    const img = new Image();
    img.onload = () => {
      try {
        const canvas = document.createElement('canvas');
        canvas.width = px;
        canvas.height = px;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, px, px);
        const r = px * 0.34;
        const cx = px - r;
        const cy = r;
        ctx.beginPath();
        ctx.arc(cx, cy, r, 0, 2 * Math.PI);
        ctx.fillStyle = '#ff3b30';
        ctx.fill();
        ctx.fillStyle = '#ffffff';
        ctx.font = `bold ${Math.round(px * 0.5)}px -apple-system, Arial, sans-serif`;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(count > 9 ? '9+' : String(count), cx, cy + px * 0.04);
        link.href = canvas.toDataURL('image/png');
      } catch (e) {
        /* favicon es best-effort; el título sigue avisando */
      }
    };
    img.src = cleanFaviconHref(link);
  });
};

// Título "apagado" del parpadeo: el nombre del cliente ("{Cliente} · CRM").
// Si por alguna razón no hay título base, cae al título original capturado.
const offTitle = () => baseTitle || originalTitle || `(${count}) ${BASE_NAME}`;

const tick = () => {
  showAlt = !showAlt;
  document.title = showAlt && lastName ? `💬 ${lastName} escribió` : offTitle();
};

const reset = () => {
  if (blinkTimer) {
    clearInterval(blinkTimer);
    blinkTimer = null;
  }
  document.title = baseTitle || originalTitle || BASE_NAME;
  document.querySelectorAll('link.favicon').forEach(link => {
    link.href = cleanFaviconHref(link);
  });
  count = 0;
  lastName = '';
  showAlt = false;
};

// Fija el título base de esta pestaña (nombre del cliente del chat abierto).
// Si no hay aviso parpadeando, lo refleja de una vez en la pestaña.
export const setTabBaseTitle = title => {
  baseTitle = title || null;
  if (!blinkTimer) document.title = baseTitle || originalTitle || BASE_NAME;
};

const bindReset = () => {
  if (listenerBound) return;
  listenerBound = true;
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') reset();
  });
  window.addEventListener('focus', reset);
};

export const triggerTabActivityAlert = ({ name } = {}) => {
  // Solo tiene sentido si la pestaña NO está al frente.
  if (document.visibilityState === 'visible' && document.hasFocus()) return;
  captureOriginals();
  bindReset();
  count += 1;
  if (name) lastName = name;
  paintFavicon();
  tick();
  if (!blinkTimer) blinkTimer = setInterval(tick, BLINK_MS);
};

export default triggerTabActivityAlert;
